export const COVER_ICON_OPTIONS = [
  "🎧", "🎵", "❤️", "🎉", "🎂", "🪩", "🕺", "💃", "💅", "😔", "😭", "😎",
  "⚽", "🚗", "💯", "💋", "🎸", "🤜", "☀️", "🌧️", "👨‍👩‍👧", "👑", "🎅",
  "🌸", "🌈", "🌙", "🪽", "☕", "🍺", "🍷", "🚨", "🎯", "🎮", "🎹", "🎤",
  "📺", "💸", "🚽", "🛁", "✏️", "⏰", "🔊", "🔍", "🔒", "⚠️", "🛑", "✅", "❌",
  "🔥", "✨", "💿", "🌊", "📻"
];

export const COVER_FONT_OPTIONS = [
  "Inter",
  "Space Grotesk",
  "Playfair Display",
  "Archivo Black",
  "DM Mono",
  "Pacifico",
  "Bungee",
  "Permanent Marker",
  "Monoton",
];

// Map display names to CSS font family names (Google Fonts uses the same names with spaces)
export const COVER_FONT_FAMILY_MAP: Record<string, string> = {
  "Inter": "Inter",
  "Space Grotesk": "Space Grotesk",
  "Playfair Display": "Playfair Display",
  "Archivo Black": "Archivo Black",
  "DM Mono": "DM Mono",
  "Pacifico": "Pacifico",
  "Bungee": "Bungee",
  "Permanent Marker": "Permanent Marker",
  "Monoton": "Monoton",
};

export const COVER_COLOR_OPTIONS = [
  "#111827",
  "#1D3557",
  "#38ccf5",
  "#4C1D95",
  "#064E3B",
  "#7C2D12",
  "#991B1B",
  "#1E293B",
  "#000000",
  "#FFFFFF",
  "#E4FF1A",
  "#FF0054",
  "#f578e6",
  "#290057",
  "#DC3AFC",
  "#4649f2",
];

export const COVER_FONT_COLOR_OPTIONS = [
  "#FFFFFF",
  "#000000",
];

export const DEFAULT_COVER_COLOR = "#111827";
export const DEFAULT_COVER_LABEL = "Mixtape";
export const DEFAULT_COVER_ICON = "__lsntoAppIcon__";
export const DEFAULT_COVER_ICON_IMAGE = "/lsntoAppIcon.png";
export const DEFAULT_COVER_FONT = "Inter";
export const DEFAULT_COVER_FONT_COLOR = "#FFFFFF";
